import { UPDATE_REPORT, RESET_REPORT } from "./actionTypes";
import * as Yup from "yup";

const reportBase = {
    id: '',
    description:'',
    status_id:'',
    operator_id:'',
    stop_id:'',
    service_order_id:'',
    trailer_id:'',
    truck_id:'',
    trailer_failure:false,
    truck_failure:false
}
const initialState = {
    report: { ...reportBase },
    validations: {
        internalId: Yup.string().required("Internal ID is required"),
        supplier_id: Yup.string().required("Supplier is required"),
        description: Yup.string().required("Report description is required"),
        estimated_cost: Yup.number()
            .typeError("Estimated cost must be a number")
            .required("Estimated cost is required"),
        creation_date: Yup.date()
            .typeError("Creation date must be a valid date")
            .required("Creation date is required"),
        due_date: Yup.date()
            .typeError("Due date must be a valid date")
            .min(Yup.ref("creation_date"), "Due date must be on or after creation date")
            .required("Due date is required"),
        truck_id: Yup.string().nullable(),
        trailer_id: Yup.string().nullable(),
    }
};

const report = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_REPORT:
            // Actualizar el estado
            return  {
                ...state,
                report: action.payload
            };
        case RESET_REPORT:
            return {
                ...state,
                report: { ...reportBase }
            };
        default:
            return state;
    }
};

export default report;
